import { getFilterParamsFromColumnSettings } from '../../../report-common';
import { columnSettings, getReportColumnSettings } from './column-settings';
//////////////////////////////////////////////////

export const RATING_FILTER_PARAMS = getFilterParamsFromColumnSettings(columnSettings);
export const REPORT_FILTER_PARAMS = getFilterParamsFromColumnSettings(getReportColumnSettings());
